import GetPublicHolidaysRequestModelBase from '../_generated/modelBases/get-public-holidays-request-model-base';

export default class GetPublicHolidaysRequestModel extends GetPublicHolidaysRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
